import { module as Module } from 'modujs';
import { $hasMenuOpen, $hasPlayerOpen, $isAutoplayable } from '../stores/state';

export default class VideoInline extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onMenuOpenChange = this.onMenuOpenChange.bind(this);
        this.onPlayerOpenChange = this.onPlayerOpenChange.bind(this);

        // UI
        this.$video = this.el;

        // Data
        this.isInview = false;
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.bindEvents();
    }

    destroy() {
        this.unbindEvents();
        super.destroy();
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    bindEvents() {
        this.unbindMenuOpenListener = $hasMenuOpen.listen(this.onMenuOpenChange);
        this.unbindPlayerOpenListener = $hasPlayerOpen.listen(this.onPlayerOpenChange);
    }

    unbindEvents() {
        this.unbindMenuOpenListener?.();
        this.unbindPlayerOpenListener?.();
    }
    // =============================================================================
    // Callbacks
    // =============================================================================
    onMenuOpenChange(hasMenuOpen) {
        if (hasMenuOpen) {
            this.pause();
        } else {
            if (this.isInview) this.play();
        }
    }

    onPlayerOpenChange(hasPlayerOpen) {
        if (hasPlayerOpen.state) {
            this.pause();
        } else {
            if (this.isInview) this.play();
        }
    }

    onInview({ way }) {
        if (way === 'enter' && !this.isInview) {
            this.$video.muted = true;
            this.play();
            this.isInview = true;
        } else if (way === 'leave' && this.isInview) {
            this.pause();
            this.isInview = false;
        }
    }

    // =============================================================================
    // Methods
    // =============================================================================
    async play() {
        try {
            if (this.$video.paused && $isAutoplayable.value) {
                await this.$video.play();
                $isAutoplayable.set(true);
            }
        } catch (err) {
            this.$video.classList.add('is-first-playing');
            this.$video?.parentNode?.classList.add('is-first-playing');
            $isAutoplayable.set(false);
        }

        if (!$isAutoplayable.value) {
            this.$video.classList.add('is-first-playing');
            this.$video?.parentNode?.classList.add('is-first-playing');
        }
    }

    pause() {
        if (!this.$video.paused) this.$video.pause();
    }
}
